var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-10"},[_c('div',{staticClass:"flex justify-center text-center flex-col gap-2 py-5"},[_c('JadeText',{attrs:{"color":"medium","variant":"heading-xsmall"}},[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_c('JadeText',{attrs:{"color":"medium","variant":"medium"}},[_vm._v(" "+_vm._s(_vm.$t('description'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }